module.exports = __webpack_public_path__ + "static/media/skip-match-button.b0df0afe.svg";